var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLightningOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.406 2.852C8.50276 2.60077 8.67348 2.38482 8.8956 2.23269C9.11772 2.08056 9.38078 1.99942 9.65 2H18.166C19.093 2 19.736 2.922 19.418 3.792L17.324 9.5H22.161C23.339 9.5 23.938 10.916 23.118 11.762L9.784 25.503C8.644 26.678 6.678 25.62 7.031 24.021L8.691 16.5H5.917C5.60548 16.4999 5.29867 16.424 5.02312 16.2786C4.74756 16.1333 4.51158 15.923 4.33559 15.666C4.15959 15.409 4.0489 15.1129 4.01307 14.8034C3.97725 14.494 4.01739 14.1805 4.13 13.89L8.406 2.852Z",
    fill: "#FFD400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLightningOn);
export default __webpack_public_path__ + "static/media/ic-lightning-on.4460530862dadc8da7c42edc629d3602.svg";
export { ForwardRef as ReactComponent };